import type FormPage from '@/modules/common/common/models/APP/FormPage'
import ForWhomForm from '@/modules/common/rater/views/forms/ForWhomForm.vue'
import MoreInfoForm from '@/modules/common/rater/views/forms/MoreInfoForm.vue'
import StartDateForm from '@/modules/common/rater/views/forms/StartDateForm.vue'
import CopayForm from '@/modules/health/rater/views/pages/CopayForm.vue'
import InsuranceTypeForm from '@/modules/health/rater/views/pages/InsuranceTypeForm.vue'

export default {
  ForWhom: {
    form: ForWhomForm,
    next: ['InsuranceTypeForm']
  },
  InsuranceTypeForm: {
    form: InsuranceTypeForm,
    next: ['CopayForm', 'StartDateForm']
  },
  CopayForm: {
    form: CopayForm,
    next: ['StartDateForm']
  },
  StartDateForm: {
    form: StartDateForm,
    next: ['MoreInfoForm']
  },
  MoreInfoForm: {
    form: MoreInfoForm,
    next: [],
    extra: { useTooOldGreaterOrEqual: true }
  }
} as Record<string, FormPage>
